import * as localforage from "localforage";

export class LocalForageProvider {
    public localForage = localforage;

    public $get() {
        return this.localForage;
    };

    public static instance() {
        return new LocalForageProvider();
    }
}